import React from "react";
import { Button, Input, Modal, Select, Table, Tag } from "antd";
import agent from "agent";
import helper from "utils/helper";

const Option = Select.Option;

const statusText = {
    1: "待开票",
    2: "已开票",
};

class InvoiceList extends React.Component {
    state = {
        data: [],
        total: 0,
        loading: false,
        page: 1,
        size: 10,
        orderid: "",
        userId: "",
        receipt: undefined,
        detail: null,
    };

    componentDidMount() {
        this.load();
    }

    load = (page = this.state.page, size = this.state.size) => {
        this.setState({ loading: true });
        const params = { page, size, orderby: "-id" };
        if (this.state.orderid.trim()) params.orderid = this.state.orderid.trim();
        if (this.state.userId.trim()) params.user_id = this.state.userId.trim();
        if (this.state.receipt) params.receipt = this.state.receipt;

        agent.Purchase.invoices(params)
            .then(response => {
                const body = response.body || {};
                this.setState({
                    data: body.invoices || [],
                    total: body.total || 0,
                    page: body.page || page,
                    size: body.size || size,
                    loading: false,
                });
            })
            .catch(() => this.setState({ loading: false }));
    };

    reset = () => {
        this.setState(
            { orderid: "", userId: "", receipt: undefined, page: 1 },
            () => this.load(1, this.state.size)
        );
    };

    columns = [
        { title: "订单号", dataIndex: "orderid", width: 260 },
        { title: "用户ID", dataIndex: "user_id", width: 90 },
        {
            title: "发票名称",
            width: 180,
            render: record => record.invoice.name || "-",
        },
        {
            title: "纳税人识别号",
            width: 180,
            render: record => record.invoice.taxpayer_number || "-",
        },
        {
            title: "开票邮箱",
            width: 220,
            render: record => record.invoice.email || "-",
        },
        {
            title: "申请时间",
            width: 160,
            render: record => helper.showDate(record.create_at),
        },
        {
            title: "状态",
            width: 90,
            render: record => (
                <Tag color={record.receipt === 2 ? "green" : "orange"}>
                    {statusText[record.receipt] || "未知"}
                </Tag>
            ),
        },
        {
            title: "操作",
            width: 80,
            fixed: "right",
            render: record => (
                <Button type="link" onClick={() => this.setState({ detail: record })}>
                    查看
                </Button>
            ),
        },
    ];

    renderDetail = () => {
        const { detail } = this.state;
        if (!detail) return null;
        const invoice = detail.invoice || {};
        return (
            <Modal
                title="开票信息"
                visible
                footer={null}
                onCancel={() => this.setState({ detail: null })}
            >
                <p>订单号：{detail.orderid}</p>
                <p>用户 ID：{detail.user_id}</p>
                <p>发票名称：{invoice.name || "-"}</p>
                <p>纳税人识别号：{invoice.taxpayer_number || "-"}</p>
                <p>邮箱：{invoice.email || "-"}</p>
                <p>地址：{invoice.address || "-"}</p>
                <p>电话：{invoice.phone || "-"}</p>
                <p>开户银行：{invoice.bank_name || "-"}</p>
                <p>银行账号：{invoice.bank_account || "-"}</p>
                <p>订单金额：{helper.showAudioMoney(detail.price)}</p>
                <p>申请时间：{helper.showDate(detail.create_at)}</p>
                <p>状态：{statusText[detail.receipt] || "未知"}</p>
            </Modal>
        );
    };

    render() {
        const { data, total, loading, page, size } = this.state;
        return (
            <div style={{ padding: 24 }}>
                <div style={{ marginBottom: 20 }}>
                    <Input
                        placeholder="订单号"
                        value={this.state.orderid}
                        onChange={e => this.setState({ orderid: e.target.value })}
                        style={{ width: 270, marginRight: 12 }}
                    />
                    <Input
                        placeholder="用户ID"
                        value={this.state.userId}
                        onChange={e => this.setState({ userId: e.target.value })}
                        style={{ width: 120, marginRight: 12 }}
                    />
                    <Select
                        allowClear
                        placeholder="开票状态"
                        value={this.state.receipt}
                        onChange={receipt => this.setState({ receipt })}
                        style={{ width: 120, marginRight: 12 }}
                    >
                        <Option value={1}>待开票</Option>
                        <Option value={2}>已开票</Option>
                    </Select>
                    <Button type="primary" onClick={() => this.load(1, size)}>
                        查询
                    </Button>
                    <Button style={{ marginLeft: 8 }} onClick={this.reset}>
                        重置
                    </Button>
                </div>
                <Table
                    rowKey={record => record.id}
                    columns={this.columns}
                    dataSource={data}
                    loading={loading}
                    scroll={{ x: 1250 }}
                    pagination={{
                        current: page,
                        pageSize: size,
                        total,
                        showSizeChanger: true,
                        onChange: (nextPage, nextSize) => this.load(nextPage, nextSize),
                        onShowSizeChange: (nextPage, nextSize) =>
                            this.load(nextPage, nextSize),
                    }}
                />
                {this.renderDetail()}
            </div>
        );
    }
}

export default InvoiceList;
